// extracted by mini-css-extract-plugin
export var bodySections = "_az-8";
export var gray = "_az-7";
export var green = "_az-4";
export var iconContainer = "_az-9";
export var iconWidgetContainer = "_az-1";
export var phoneIcon = "_az-2";
export var red = "_az-5";
export var statusDot = "_az-3";
export var widgetContainer = "_az-0";
export var yellow = "_az-6";